module.exports = __webpack_public_path__ + "img/徐长卿.cc58c13c.jpg";